<template>
    <div class="mb-3 mt-5">
        <form v-if="!changed" class="form-resetpassword" @submit.prevent="submit"
              ref="registro-form-form"
              novalidate
              :class="{
                'validated': validated,
            }">
            <h2 class="h2 mb-4 fw-normal">Restablecer Contraseña</h2>
            <div class="form-floating mb-3">
                <input type="password" class="form-control" placeholder="Nueva contraseña"
                       autocomplete="off"
                       :class="{
                                'form-control': true,
                                'is-invalid': validated && (password == '' || password != repeatPassword),
                                'is-valid': validated && password != '' && password == repeatPassword
                            }"
                       name="password"
                       id="registro-form-password"
                       v-model="password">
                <div class="invalid-feedback">Password inválido</div>
            </div>
            <div class="form-floating mb-3">
                <input type="password" class="form-control"
                       placeholder="Repetir la contraseña" autocomplete="off"
                       :class="{
                                'form-control': true,
                                'is-invalid': validated && (repeatPassword == '' || password != repeatPassword),
                                'is-valid': validated && repeatPassword != '' && password == repeatPassword
                            }"
                       name="repeat-password"
                       id="registro-form-repeat"
                       v-model="repeatPassword">
                <div class="invalid-feedback">El password no coincide</div>
            </div>
            <button class="w-100 btn btn-lg btn-primary" type="submit">Cambiar contraseña</button>
            <br>
            <div class="perfil-alert"
                 v-if="alert.visible">
                <font-awesome-icon
                    :icon="alert.icon"
                    :class="{
                        'color-orange': true,
                        spin: alert.iconSpin
                    }"/>
                {{ alert.message }}
            </div>
        </form>

        <div v-if="changed">
            <h1>Contraseña modificada con éxito</h1>
            <button @click="toggleLoginModal(true)" class="btn btn-lg btn-primary mt-4" style="height: 50px">Iniciar Sesión</button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {mapGetters} from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {randomString, isValidEmail} from "../utilities/util";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faCheck,
    faSpinner,
    faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import bButton from "bootstrap-vue/es/components/button";

library.add(faCheck, faSpinner, faExclamationTriangle);

export default {
    components: {
        VueGoogleAutocomplete,
        FontAwesomeIcon,
        bButton,
    },
    props: ["TOKEN_CLAVE_RECUPERAR"],
    data() {
        return {
            alert: {
                message: "",
                visible: false,
                icon: "",
                iconSpin: false
            },
            id: 0,
            label: null,
            isSubmitting: false,
            password: "",
            repeatPassword: "",
            validated: false,
            changed: false,
        };
    },
    computed: {
        ...mapGetters(["user", "portal"])
    },
    methods: {
        submit(e) {
            this.validated = true;
            let isValid = true;
            if (this.password != this.repeatPassword || this.password == "")
                isValid = false;

            let newUserData = {
                TOKEN_CLAVE_RECUPERAR: this.$route.params.token,
                password: this.password
            };

            if (isValid) {
                this.showAlert({
                    iconSpin: true,
                    message: "Guardando...",
                    icon: "spinner"
                });
                this.$api
                    .restablecer_password(newUserData)
                    .then(response => {
                        if (response.data.response != "200") {
                            this.changed = false
                            this.showAlert({
                                iconSpin: true,
                                message: "Error al guardar los datos...",
                                icon: "spinner"
                            });

                            setTimeout(() => {
                                this.$router.push({
                                    name: "olvido_password"
                                });
                            }, 1000);
                        } else {
                            this.changed = true

                        }
                    })
                    .catch(error => {
                        this.changed = false
                        this.showAlert({
                            iconSpin: true,
                            message: "Error al guardar los datos...",
                            icon: "spinner"
                        });
                        setTimeout(() => {
                            this.$router.push({
                                name: "olvido_password"
                            });
                        }, 1000);
                    });
            }
        },
        showAlert(options, autoHide) {
            this.alert.visible = true;
            this.alert = Object.assign(this.alert, options);
            if (autoHide)
                setTimeout(() => {
                    this.alert.visible = false;
                }, 3000);
        },
        toggleLoginModal(toggle) {
            this.$store.commit("togglePortalLoginModal", toggle);
            if (screen.width <= 500) {
                this.$store.commit("togglePortalBarraPrecioFooterModal", toggle);
            }
            this.$router.push({ name: "home" });
        },
    }
};
</script>

<style scoped>
.form-resetpassword {
    width: 100%;
    max-width: 370px;
    padding: 15px;
    margin: auto;
}
</style>
